import * as types from './spedilink-mutation-types'

const getDefaultState = () => ({
  eventVersion: 0,
  lastEvent: null,
  lastEventAt: null
})

const state = getDefaultState()

const getters = {
  eventVersion (state) {
    return state.eventVersion
  },
  lastEvent (state) {
    return state.lastEvent
  },
  lastEventAt (state) {
    return state.lastEventAt
  }
}

const actions = {
  onListAdded ({ commit }, linkData) {
    commit(types.PUSH_EVENT, {
      eventName: 'ListAdded',
      linkId: linkData?.id || linkData?.Id || null,
      type: linkData?.type || linkData?.Type || null,
      payload: linkData || null
    })
  },
  onListRemoved ({ commit }, linkId) {
    commit(types.PUSH_EVENT, {
      eventName: 'ListRemoved',
      linkId: linkId || null,
      payload: { linkId }
    })
  },
  onLinkOrderAdded ({ commit }, { linkId, orderViewModel, orderType }) {
    commit(types.PUSH_EVENT, {
      eventName: 'LinkOrderAdded',
      linkId: linkId || null,
      orderId: orderViewModel?.id || orderViewModel?.Id || null,
      orderType: orderType || null,
      payload: orderViewModel || null
    })
  },
  onLinkOrderModified ({ commit }, { linkId, orderViewModel, orderType }) {
    commit(types.PUSH_EVENT, {
      eventName: 'LinkOrderModified',
      linkId: linkId || null,
      orderId: orderViewModel?.id || orderViewModel?.Id || null,
      orderType: orderType || null,
      payload: orderViewModel || null
    })
  },
  onLinkOrderRemoved ({ commit }, { linkId, orderId, orderType }) {
    commit(types.PUSH_EVENT, {
      eventName: 'LinkOrderRemoved',
      linkId: linkId || null,
      orderId: orderId || null,
      orderType: orderType || null,
      payload: { orderId }
    })
  },
  onNewInterest ({ commit }, interest) {
    commit(types.PUSH_EVENT, {
      eventName: 'NewInterest',
      linkId: interest?.linkId || interest?.LinkId || null,
      orderId: interest?.orderId || interest?.OrderId || null,
      orderType: interest?.orderType || interest?.OrderType || null,
      payload: interest || null
    })
  },
  onNewOffersRead ({ commit }, data) {
    commit(types.PUSH_EVENT, {
      eventName: 'NewOffersRead',
      linkId: data?.linkId || data?.LinkId || null,
      linkType: data?.linkType ?? data?.LinkType ?? null,
      payload: data || null
    })
  },
  onInterestsRead ({ commit }, data) {
    commit(types.PUSH_EVENT, {
      eventName: 'InterestsRead',
      linkId: data?.linkId || data?.LinkId || null,
      linkType: data?.linkType ?? data?.LinkType ?? null,
      payload: data || null
    })
  },
  resetState ({ commit }) {
    commit(types.RESET_STATE)
  }
}

const mutations = {
  [types.PUSH_EVENT] (state, event) {
    state.eventVersion += 1
    state.lastEvent = event
    state.lastEventAt = Date.now()
  },
  [types.RESET_STATE] (state) {
    Object.assign(state, getDefaultState())
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
